<template>
  <div class="assessmentModule">
    <div class="searchRow">
      <el-date-picker
        v-model="searchDateStart"
        class="tableSearch"
        type="date"
        placeholder="开始时间"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-date-picker
        v-model="searchDateEnd"
        class="tableSearch"
        type="date"
        placeholder="结束时间"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <div class="btnCol">
        <el-button class="search" @click="handleSearch">查询</el-button>
        <el-button class="out" @click="handleExport">导出</el-button>
      </div>
    </div>
    <div class="tableWrap">
      <el-table
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        :data="tableData"
        stripe
        style="width: 100%"
        height="100%"
      >
        <el-table-column prop="nickname" label="姓名" align="center" min-width="120"></el-table-column>
        <el-table-column
          prop="project_count"
          label="立项数量"
          align="center"
          min-width="110"
        ></el-table-column>
        <el-table-column
          prop="sign_count"
          label="签订数量"
          align="center"
          min-width="110"
        ></el-table-column>
        <el-table-column
          prop="unsign_count"
          label="未签数量"
          align="center"
          min-width="110"
        ></el-table-column>
        <el-table-column
          prop="hetong_money"
          label="合同金额"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="daozhang_money"
          label="到账金额"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="weihui_money"
          label="未回金额"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="shui_money" label="发票" align="center" min-width="90"></el-table-column>
        <el-table-column
          prop="yewujiesuan_money"
          label="业务结算"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="xmjiesuan_money"
          label="项目结算"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="zhjf_money"
          label="项目专家费"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="baoxiao_money" label="报销" align="center" min-width="90"></el-table-column>
        <el-table-column
          prop="zizhi_money"
          label="资质费"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <el-button class="tableBtn" @click="handleCheck(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="86%"
      class="detailDialog"
      :before-close="handleDialogClose"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-name" v-if="detailUserName">{{ detailUserName }}</span>
        <span class="title-age">业务考核详情</span>
      </div>
      <div class="diaContainer">
        <div class="searchRow detailSearchRow">
          <el-input
            v-model="detailSearch"
            class="tableSearch projectSearch"
            placeholder="项目名称"
            clearable
          ></el-input>
          <el-date-picker
            v-model="detailDateStart"
            class="tableSearch"
            type="date"
            placeholder="开始时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-date-picker
            v-model="detailDateEnd"
            class="tableSearch"
            type="date"
            placeholder="结束时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <div class="btnCol">
            <el-button class="search" @click="handleDetailSearch">查询</el-button>
            <el-button class="out" @click="handleDetailExport">导出</el-button>
          </div>
        </div>
        <el-table
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          :data="detailTableData"
          stripe
          style="width: 100%; margin-top: 20px"
          height="60vh"
        >
          <el-table-column
            prop="company_name"
            label="项目名称"
            align="center"
            min-width="220"
            show-overflow-tooltip
          ></el-table-column>
           <el-table-column
            prop="project_years"
            label="项目年份"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column prop="nickname" label="立项人员" align="center" min-width="120"></el-table-column>
          <el-table-column
            prop="is_sign"
            label="是否签约"
            align="center"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="is_archive"
            label="是否存档"
            align="center"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="hetong_money"
            label="合同金额"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="daozhang_money"
            label="到账金额"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="weihui_money"
            label="未回金额"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column prop="shui_money" label="发票" align="center" min-width="90"></el-table-column>
          <el-table-column
            prop="yewujiesuan_money"
            label="业务结算"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="xmjiesuan_money"
            label="项目结算"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
          prop="zhjf_money"
          label="项目专家费"
          align="center"
          min-width="120"
        ></el-table-column>
          <el-table-column prop="baoxiao_money" label="报销" align="center" min-width="90"></el-table-column>
          <el-table-column
            prop="zizhi_money"
            label="资质费"
            align="center"
            min-width="100"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      searchDateStart: '',
      searchDateEnd: '',
      tableData: [],
      dialogVisible: false,
      detailUserId: '',
      detailUserName: '',
      detailSearch: '',
      detailDateStart: '',
      detailDateEnd: '',
      detailTableData: [],
      tableHeaderStyle: {
        background: '#40A0F2',
        padding: '20px 0',
        color: '#fff',
        fontSize: '18px',
        fontWeight: '400',
      },
      tableCellStyle: {
        borderBottom: 'none',
        color: '#333',
        fontSize: '16px',
        padding: '13px 0',
        fontWeight: '400',
      },
    }
  },
  methods: {
    getErrorMsg(res, fallback = '请求失败') {
      if (res && res.datas && res.datas.msg) return res.datas.msg
      if (res && res.msg) return res.msg
      return fallback
    },
    createBaseParams() {
      const param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      return param
    },
    appendDateRange(param, start, end) {
      if (start) param.append('date_start', start)
      if (end) param.append('date_end', end)
    },
    downloadByUrl(fileUrl) {
      if (!fileUrl) return
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = fileUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async getAssessmentList() {
      const param = this.createBaseParams()
      this.appendDateRange(param, this.searchDateStart, this.searchDateEnd)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/assessment_statistics',
        data: param,
      })
      if (res.code != 200) return this.$message.error(this.getErrorMsg(res))
      this.tableData = (res.datas && res.datas.listInfo) || []
    },
    async getAssessmentDetailList() {
      if (!this.detailUserId) return
      const param = this.createBaseParams()
      param.append('to_member_id', this.detailUserId)
      this.appendDateRange(param, this.detailDateStart, this.detailDateEnd)
      if (this.detailSearch) {
        param.append('search', this.detailSearch)
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/assessment_statistics_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(this.getErrorMsg(res))
      this.detailTableData = (res.datas && res.datas.listInfo) || []
    },
    async handleExport() {
      const param = this.createBaseParams()
      this.appendDateRange(param, this.searchDateStart, this.searchDateEnd)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Doc/assessment_statistics_output',
        data: param,
      })
      if (res.code != 200) return this.$message.error(this.getErrorMsg(res))
      this.downloadByUrl(res.datas && res.datas.file_url)
    },
    async handleDetailExport() {
      if (!this.detailUserId) return
      const param = this.createBaseParams()
      param.append('to_member_id', this.detailUserId)
      this.appendDateRange(param, this.detailDateStart, this.detailDateEnd)
      if (this.detailSearch) {
        param.append('search', this.detailSearch)
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Doc/assessment_statistics_detail_output',
        data: param,
      })
      if (res.code != 200) return this.$message.error(this.getErrorMsg(res))
      this.downloadByUrl(res.datas && res.datas.file_url)
    },
    handleSearch() {
      this.getAssessmentList()
    },
    handleDetailSearch() {
      this.getAssessmentDetailList()
    },
    handleCheck(row) {
      this.detailUserId = row.member_id
      this.detailUserName = row.nickname || ''
      this.detailDateStart = this.searchDateStart
      this.detailDateEnd = this.searchDateEnd
      this.detailSearch = ''
      this.dialogVisible = true
      this.getAssessmentDetailList()
    },
    handleDialogClose() {
      this.dialogVisible = false
      this.detailTableData = []
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getAssessmentList()
  },
}
</script>

<style lang="less" scoped>
.assessmentModule {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .searchRow {
    display: flex;
    align-items: center;
    width: 100%;
    flex-shrink: 0;
  }

  .tableSearch {
    width: 220px;
    margin-right: 20px;
  }

  .projectSearch {
    width: 260px;
  }

  .btnCol {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .btnCol /deep/ .el-button {
    font-size: 18px;
    font-weight: 400;
    border: none;
    width: 130px;
    height: 45px;
    color: #fff;
    border-radius: 24px;
    padding: 0;
    margin-left: 20px;
  }

  .search {
    background: #f4a029;
  }

  .out {
    background: #0099ff;
  }

  .tableWrap {
    flex: 1;
    min-height: 0;
    margin-top: 20px;
  }

  .tableBtn {
    padding: 0;
    width: 88px;
    height: 32px;
    border-color: #66c16f;
    color: #10981d;
    border-radius: 5px;
    font-weight: 400;
  }

  .title-name {
    color: #128bf1;
    margin-right: 5px;
  }

  .diaContainer {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 10px 0;
  }

  .detailSearchRow {
    padding-right: 10px;
  }

  /deep/ .el-input__inner {
    height: 45px;
    border-radius: 24px;
    font-size: 16px;
    border: none;
    background-color: #f4f5f6;
    color: #333;
  }

  /deep/ .el-table__header th {
    border-color: #40a0f2 !important;
  }

  /deep/ .el-table__header .gutter {
    background-color: #40a0f2;
  }

  /deep/ .el-table::before {
    display: none;
  }

  /deep/ .el-table__body-wrapper {
    box-sizing: border-box;
    border: 1px solid #f4f5f6;
  }

  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #eff8ff;
  }

  /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #f4f5f6;
  }

  /deep/ .detailDialog .el-dialog {
    border-radius: 10px;
  }

  /deep/ .detailDialog .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding: 20px 40px;
  }

  /deep/ .detailDialog .el-dialog__body {
    padding: 24px 32px 32px;
  }
}
</style>
